.action-text {
    color: var(--blue);
}
